import type { SVGProps } from 'react';

const TwoWaySyncIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.875 10.0625C0.875 10.3041 1.07088 10.5 1.3125 10.5H11.6313L8.87814 13.2531C8.70729 13.424 8.70729 13.701 8.87814 13.8719C9.049 14.0427 9.326 14.0427 9.49686 13.8719L12.9969 10.3719C13.1677 10.201 13.1677 9.924 12.9969 9.75314L9.49686 6.25314C9.326 6.08229 9.049 6.08229 8.87814 6.25314C8.70729 6.424 8.70729 6.70101 8.87814 6.87186L11.6313 9.625H1.3125C1.07088 9.625 0.875 9.82088 0.875 10.0625Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.125 3.9375C13.125 4.17912 12.9291 4.375 12.6875 4.375L2.36872 4.375L5.12186 7.12814C5.29271 7.29899 5.29271 7.57601 5.12186 7.74686C4.951 7.91771 4.674 7.91771 4.50314 7.74686L1.00314 4.24686C0.832286 4.07601 0.832286 3.799 1.00314 3.62814L4.50314 0.128141C4.674 -0.0427136 4.951 -0.0427136 5.12186 0.128141C5.29271 0.298995 5.29271 0.576006 5.12186 0.74686L2.36872 3.5L12.6875 3.5C12.9291 3.5 13.125 3.69588 13.125 3.9375Z"
      fill="currentColor"
    />
  </svg>
);

export default TwoWaySyncIcon;
